"use strict";

export class Physics {
    static __engine;
    static get engine() { return Physics.__engine; }
    static __runner;
    static get runner() { return Physics.__runner; }

    // Performance
    static __framerates = [
        1000 / 60,
        1000 / 120,
        1000 / 144,
        1000 / 240,
        1000 / 360
    ];
    static __currentFramerate = 0;

    // Objects
    static __bodies = [];
    static __addedCollisionEvent = false;

    static __version = "0.0.0.4";
    static get version() { return Physics.__version; }

    static initialize(isFixedFrameRate) {
        Physics.__engine = Matter.Engine.create();
        SimpleEngine.Application.main.ticker.add(() => {
            Physics.__bodies.forEach((body) => body.__draw());
        });
        Physics.__runner = Matter.Runner.create({
            isFixed: isFixedFrameRate ?? false
        });
        Matter.Runner.run(Physics.__runner, Physics.__engine);
        Matter.Resolver._restingThresh = 0.01;
    }

    static toggleCollisionCheck(value,callback) {
        if (value == Physics.__addedCollisionEvent) return;

        if (value) {
            Matter.Events.on(Physics.__engine, "collisionStart", callback);
        } else {
            Matter.Events.off(Physics.__engine, "collisionStart", callback);
        }

        Physics.__addedCollisionEvent = value;
    }

    static add(object,type,properties) {
        if (properties.ignoreGravity) {
            properties.isStatic = true;
        }

        switch (type) {
            case "circle":
                let radius = object.height * 0.5;

                object.body = Matter.Bodies.circle(
                    object.getX(),
                    object.getY(),
                    radius,
                    properties
                );
                break;
            case "rectangle":
                object.body = Matter.Bodies.rectangle(
                    object.getX(),
                    object.getY(),
                    object.width,
                    object.height,
                    properties
                );
                break;
            case "shape":
                let isStatic = properties.isStatic ?? false;
                if (isStatic) {
                    properties.isStatic = undefined;
                }

                let shape = object.shape;
                let vertices = [];
                for (let i = 0, j = 0; i < shape.length; i += 2, j++) {
                    vertices.push(Matter.Vector.create(shape[i], shape[i + 1]));
                }

                object.body = Matter.Bodies.fromVertices(
                    object.getX(),
                    object.getY(),
                    vertices,
                    properties
                );

                Matter.Body.setStatic(object.body, isStatic);
                break;
        }

        object.body.graphics = object;
        object.body.enabled = properties.enabled ?? true;

        if (object.name !== undefined) {
            object.body.tag = object.name;

            if (object.body.parts.length > 1) {
                for (let i = 1; i < object.body.parts.length; i++) {
                    object.body.parts[i].tag = object.name;
                }
            }
        }

        object._onDispose.registerCallback(() => Physics.dispose(object));
        object.body.__draw = () => Physics.__draw(object);
        object.draw = object.body.__draw;
        object._setPosition = object.setPosition;
        object.setPosition = (x,y) => Physics.__setPosition(object, x, y);
        object.setVelocity = (x,y) => Physics.__setVelocity(object, x, y);
        object.setAngularVelocity = (velocity) => Physics.__setAngularVelocity(object, velocity);
        object.rotate = (degrees) => Physics.__rotate(object, degrees);

        Physics.__bodies.push(object.body);

        Matter.World.addBody(Physics.__engine.world, object.body);

        object.draw();
    }

    static dispose(object) {
        Physics.__bodies.splice(Physics.__bodies.indexOf(object.body), 1);
        Matter.World.remove(Physics.__engine.world, object.body, true);
        object.body = undefined;
    }

    static __draw(object) {
        object.setX(object.body.position.x);
        object.setY(object.body.position.y);
        object.angle = Math.radiansToDegrees(object.body.angle);
    }

    static __setPosition(object,x,y) {
        if (typeof x === "number") {
            Matter.Body.setPosition(object.body, x, y);
        } else {
            Matter.Body.setPosition(object.body, x);
        }
        object.body.__draw();
    }

    static __setVelocity(object,x,y) {
        if (typeof x === "number") {
            Matter.Body.setVelocity(object.body, x, y);
        } else {
            Matter.Body.setVelocity(object.body, x);
        }
        object.body.__draw();
    }
    
    static __setAngularVelocity(object,velocity) {
        Matter.Body.setAngularVelocity(object.body, velocity);
        object.body.__draw();
    }

    static __rotate(object,degrees) {
        Matter.Body.rotate(object.body, Math.degreesToRadians(degrees));
        object.body.__draw();
    }

    static checkFrameRate(isDesktop) {
        // if (!isDesktop) return;

        let targetFramerate = Physics.__getTargetFramerate();
        if (targetFramerate == Physics.__currentFramerate) return;

        Physics.__currentFramerate = targetFramerate;
        Physics.__runner.delta = Physics.__framerates[targetFramerate];
        Physics.__runner.deltaMin = Physics.__runner.delta;
        Physics.__runner.deltaMax = Physics.__runner.deltaMin * 2;
    }

    static __getTargetFramerate() {
        if (Physics.__runner.fps < 100) {
            // 60
            return 0;
        }

        if (Physics.__runner.fps < 135) {
            // 120
            return 1;
        }

        if (Physics.__runner.fps < 200) {
            // 144
            return 2;
        }

        if (Physics.__runner.fps < 300) {
            // 240
            return 3;
        }
        
        // 360
        return 4;
    }
}